(function () {
  const table = "#points-list";

  const outingEventsDatatableApp = function () {
    const init = () => {
      let url = `/outings/events/${gon.event.id}/players.json?game_type_id=${gon.game_type_id}`;

      $(table)
        .DataTable({
          lengthChange: false,
          pageLength: 5000,
          paging: false,
          info: false,
          lengthMenu: [5, 10, 25, 50, 100],
          ajax: {
            url,
          },
          order: [0, "asc"],
          ordering: true,
          columns: [
            {
              className: "vertical-align-middle",
              data: "formal_name",
            },
            {
              className: "vertical-align-middle",
              data: "team_name",
            },
            {
              className: "vertical-align-middle",
              data: "gross_scores",
            },
            {
              className: "vertical-align-middle",
              data: "net_scores",
            },
            {
              className: "vertical-align-middle",
              data: function (data) {
                if (!data.team_name) return "";

                return Mustache.render($("#mustache_competitor_points_input").html(), data);
              },
            },
          ],
        })
        .on("draw.dt", window.bindDatatableTooltips);
    };

    $(document).on("turbolinks:load", () => {
      if (!$("body").hasClass("controller-outings-series-points")) return;

      init();
    });
  };

  if (typeof window !== "undefined") {
    window.outingEventsDatatableApp = outingEventsDatatableApp();
  }
})();
